import set from "@rill/set";
import rill from "rill";

import getStore from "./store.controller.js";
import ProgramMetricsController from "./program-metrics/program-metrics.controller.js";

const Store = (app) => {
  app.at(
    "/store/*",
    rill()
      .use(set("heading", ["Coaching", "Store"]))
      .setup((app) => {
        app.get("/", getStore);
      })
      .setup(ProgramMetricsController)
  );
};

export default Store;
